export const AuthErrorCode = {
  InvalidToken: 'InvalidToken',
  AuthUnavailable: 'AuthUnavailable',
  ExpiredToken: 'ExpiredToken',
  AuthenticationRequired: 'AuthenticationRequired',
  InsufficientPermissions: 'InsufficientPermissions',
  MissingAuthorizationHeader: 'MissingAuthorizationHeader',
  BusinessAccessDenied: 'BusinessAccessDenied',
  BusinessAccessRequired: 'BusinessAccessRequired',
  BusinessRoleRequired: 'BusinessRoleRequired',
  AccountAlreadyExists: 'AccountAlreadyExists',
  AccountDeleted: 'AccountDeleted',
  AuthUserCreationFailed: 'AuthUserCreationFailed',
  WeakPassword: 'WeakPassword',
  PasswordTooShort: 'PasswordTooShort',
  PasswordTooLong: 'PasswordTooLong',
  RateLimited: 'RateLimited',
  EmailNotConfirmed: 'EmailNotConfirmed',
  RegistrationEmailFailed: 'RegistrationEmailFailed',
} as const
export type AuthErrorCode = (typeof AuthErrorCode)[keyof typeof AuthErrorCode]
